<template>
  <div>
    <slot></slot>
    <el-card class="box-card">
      <div
        slot="header"
        class="clearfix"
      >
        <el-input
          placeholder="请输入Api名称"
          v-model="apiName"
          class="input-with-select"
          style=" margin-right: 15px;"
        >

        </el-input>

        <!-- <el-date-picker
          v-model="time"
          type="datetimerange"
          style=" margin:0 15px;"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="selectTime"
        >
        </el-date-picker> -->
        <!--  <el-button
          @click="clear"
          id="clearBtn"
        >重置</el-button> -->
        <el-button
          @click="getmyApiList"
          id="searchBtn"
          type="primary"
        >查询</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :default-sort="{prop: 'date', order: 'descending'}"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="count"
            label="扣除数据"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="API名称"
          >
          </el-table-column>
          <el-table-column
            prop="app_key"
            sortable
            label="Appkey"
          >
          </el-table-column>
          <el-table-column
            prop="left_count"
            sortable
            label="剩余次数/剩余金额"
          >
          </el-table-column>
          <el-table-column
            prop="craete_time"
            sortable
            label="调用时间"
          >
          </el-table-column>
          <el-table-column
            prop="date"
            sortable
            label="时间"
          >
          </el-table-column>
        </el-table>
        <div class="pager">
          <el-pagination
            background
            :page-size="pagesize"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="totalcount"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import apis from "@/api/apis";
export default {
  name: 'OpenUsedetail',
  props:
  {
    appkey: Number,
    apiId: Number
  }
  ,
  data () {
    return {
      apiAppKey: '',
      apiName: '',
      pagesize: 10,
      pagenum: 1,
      totalcount: 0,
      time: '',
      startTime: '',
      endTime: '',
      tableData: [],
      options: []
    };
  },

  mounted () {
    this.getmyApiList()
  },

  methods: {
    handleCurrentChange (val) {
      this.pagenum = val
      this.getmyApiList()
    },
    getmyApiList () {

      apis.index.myApiDetailList({
        api_id: this.apiId,
        app_key: this.appkey,
        page: this.pagenum,
        page_size: this.pagesize
      }).then(res => {
        this.tableData = res.data.list
        this.totalcount = res.data.count
        console.log("567");
        this.getAppDetail()
      })
      document.getElementById("searchBtn").blur()
    },
    getAppDetail () {
      apis.app.index({
        page: 1,
        page_size: 100,
      }).then(res => {
        this.options = []
        res.data.list.forEach(item => {
          this.options.push(item.app_key)
        });

      })
    },
    clear () {
      this.apiName = []
      this.startTime = []
      this.endTime = []
      this.apiAppKey = []
      this.time = []
      this.getmyApiList()
      document.getElementById("clearBtn").blur()
    },
    //选择时间
    selectTime () {
      this.startTime = this.filterTime(this.time[0])
      this.endTime = this.filterTime(this.time[1])
    },
    //中国标准时间转换格式
    filterTime (time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    tableHeaderColor ({ rowIndex, }) {
      if (rowIndex === 0) {
        return 'background-color: #FAFAFA;color: #000;font-weight: 500;'
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box-card {
  margin-top: 15px;
  padding: 10px;
  background: #ffffff;
  .clearfix {
    display: flex;
    .input-with-select {
      margin-left: 15px;
      width: 270px;
    }
  }
  .pager {
    margin-top: 10px;
    width: 100%;
    height: 64px;
    background: #ffffff;
    padding-right: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }
  .clearfix:after {
    clear: both;
  }
}
</style>